/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_PrivacyInputs */



/**
* | output |
* | --- |
* | "Privacy policy" |
*
* @param {Login_PrivacyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_privacy = /** @type {((inputs?: Login_PrivacyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_PrivacyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Privacybeleid")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Politique de confidentialité")
	return /** @type {LocalizedString} */ ("Privacy policy")
});